// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import debug from "../helpers/debug";

const getLocationDetailReviews = (
  id: number
): ((apiInstance: AxiosInstance) => AxiosPromise) => (apiInstance) => {
  debug("getReviews", id);
  return apiInstance.get(`/v4/listings/${id}/reviews`);
};

export default getLocationDetailReviews;
